import { LessonTypesEnum } from 'types/generated/client';
import { toTitleCase } from 'utils/shared/toTitleCase';
import CoachBadge from 'svg/CoachBadge';
import Location from 'svg/Location';
import { BookedLessonCardProps } from 'screens/PlayerLoggedInScreen/props';
import LessonBadge from 'components/tournaments/LessonBadge';

const BookedLessonCard: React.FC<BookedLessonCardProps> = ({
  time,
  image,
  location,
  coachName,
  price,
  sport,
}) => {
  return (
    <div>
      <div className="flex justify-between gap-1">
        <span className="typography-product-text-card-desktop">{time}</span>
        {!!price && <span className="typography-product-card-title">{price}</span>}
      </div>
      <div className="mt-ds-md flex gap-ds-md">
        <img
          src={image}
          className="h-[5.5rem] w-[5.5rem] rounded-lg object-cover object-top"
          alt="lesson-image"
        />
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <LessonBadge
              size="xs"
              label={toTitleCase(sport)}
              variant={LessonTypesEnum.Individual}
            />
          </div>
          <h6 className="typography-product-card-title-desktop mt-1">Individual</h6>
          <div className="mt-1 flex items-center gap-1">
            <Location className="h-4 w-4 flex-shrink-0 text-color-bg-lightmode-icon dark:text-color-bg-darkmode-icon " />
            <span className="typography-product-text-card-desktop dark:text-color-text-darkmode-secondaryF text-color-text-lightmode-secondary">
              {location}
            </span>
          </div>
          <div className="mt-1 flex items-center gap-1">
            <CoachBadge className="h-4 w-4 flex-shrink-0 text-color-bg-lightmode-icon dark:text-color-bg-darkmode-icon " />
            <span className="typography-product-text-card-desktop dark:text-color-text-darkmode-secondaryF text-color-text-lightmode-secondary">
              {toTitleCase(coachName)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookedLessonCard;
